import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  SHARE_CARD_LAB_PRESETS,
  labDraftFromPreset,
} from "../../utils/triviaShareCardLab";
import { SHARE_CARD_TIER } from "../../utils/triviaShareCardTiers";
import TriviaShareCard from "./TriviaShareCard";

const TriviaShareCardLab = () => {
  const [draft, setDraft] = useState(() =>
    labDraftFromPreset(SHARE_CARD_LAB_PRESETS[0])
  );

  const setField = (field) => (event) => {
    const value = event.target.value;
    setDraft((current) => ({ ...current, [field]: value }));
  };

  const setNumber = (field) => (event) => {
    setDraft((current) => ({
      ...current,
      [field]: Number(event.target.value) || 0,
    }));
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
        Share card lab
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Preview teal and gold collectibles without playing those games. Presets
        fill the form; edit any field and the card updates.
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
        {SHARE_CARD_LAB_PRESETS.map((preset) => (
          <Button
            key={preset.id}
            size="small"
            variant="outlined"
            onClick={() => setDraft(labDraftFromPreset(preset))}
          >
            {preset.label}
          </Button>
        ))}
      </Stack>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "minmax(240px, 320px) 1fr" },
          gap: 3,
          alignItems: "start",
        }}
      >
        <Stack spacing={1.5}>
          <FormControl size="small" fullWidth>
            <InputLabel>Mode</InputLabel>
            <Select value={draft.mode} label="Mode" onChange={setField("mode")}>
              <MenuItem value="daily">Daily</MenuItem>
              <MenuItem value="quick">Quick</MenuItem>
              <MenuItem value="custom">Custom</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth>
            <InputLabel>Sport</InputLabel>
            <Select
              value={draft.sportLabel}
              label="Sport"
              onChange={setField("sportLabel")}
            >
              <MenuItem value="MLB">MLB</MenuItem>
              <MenuItem value="NBA">NBA</MenuItem>
              <MenuItem value="NFL">NFL</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth>
            <InputLabel>Tier</InputLabel>
            <Select value={draft.tier} label="Tier" onChange={setField("tier")}>
              <MenuItem value="">Auto from score</MenuItem>
              <MenuItem value={SHARE_CARD_TIER.TEAL}>Force teal</MenuItem>
              <MenuItem value={SHARE_CARD_TIER.GOLD}>Force gold</MenuItem>
            </Select>
          </FormControl>
          <TextField
            size="small"
            label="Grade"
            value={draft.grade}
            onChange={setField("grade")}
          />
          <TextField
            size="small"
            type="number"
            label="Correct"
            value={draft.correct}
            onChange={setNumber("correct")}
          />
          <TextField
            size="small"
            type="number"
            label="Total"
            value={draft.total}
            onChange={setNumber("total")}
          />
          <TextField
            size="small"
            type="number"
            label="Score"
            value={draft.score}
            onChange={setNumber("score")}
          />
          <TextField
            size="small"
            label="Username"
            value={draft.username}
            onChange={setField("username")}
          />
        </Stack>
        <TriviaShareCard
          mode={draft.mode}
          grade={draft.grade}
          correct={draft.correct}
          total={draft.total}
          score={draft.score}
          sportLabel={draft.sportLabel}
          username={draft.username}
          shareToken={draft.shareToken}
          tier={draft.tier || undefined}
        />
      </Box>
    </Box>
  );
};

export default TriviaShareCardLab;
